import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import LeftPanel from '@/components/auth/left-panel';
import StepOne from '@/components/auth/signup/step-one';
import StepSuccess from '@/components/auth/signup/step-success';
import StepTwo from '@/components/auth/signup/step-two';
import { api } from '@/lib/api';
import { signupSchema, type SignupFormValues } from '@/types/auth';

export default function SignupPage() {
  const [step, setStep] = useState(1);
  const [apiError, setApiError] = useState('');
  const [loading, setLoading] = useState(false);

  const form = useForm<SignupFormValues>({
    resolver: zodResolver(signupSchema),
    defaultValues: {
      fullName: '',
      email: '',
      schoolName: '',
      password: '',
      confirmPassword: '',
    },
  });

  async function handleFinalSubmit(data: SignupFormValues) {
    setApiError('');
    setLoading(true);
    try {
      const res = await api.post<{ accessToken: string }>('/auth/signup', {
        fullName: data.fullName,
        email: data.email,
        password: data.password,
        role: data.role,
        schoolName: data.schoolName,
      });
      localStorage.setItem('token', res.accessToken);
      setStep(3);
    } catch (err) {
      setApiError(err instanceof Error ? err.message : 'Signup failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className='flex min-h-screen bg-ws-bg'>
      <LeftPanel />
      <div className='flex flex-1 items-center justify-center px-6'>
        <FormProvider {...form}>
          {step === 1 && (
            <StepOne
              onNext={() => setStep(2)}
              onBack={() => history.back()}
            />
          )}
          {step === 2 && (
            <StepTwo
              onBack={() => setStep(1)}
              onSubmit={form.handleSubmit(handleFinalSubmit)}
              apiError={apiError}
              loading={loading}
            />
          )}
          {step === 3 && <StepSuccess />}
        </FormProvider>
      </div>
    </div>
  );
}
